import {
    Input,
    Component, ViewChild, ChangeDetectorRef, ViewContainerRef, Output, EventEmitter,
    HostBinding
} from '@angular/core';

import { CandapostAutocompleteOptions, ICanadapostAddress } from './canadapost.models';
import { Configuration } from './configs/app.config';
import { AddressAutocompleteModel } from './address-autocomplete.model';
import { CountryHttpService } from './services/country.http.service';
import { HttpConfiguration } from './configs/app.http.config';
import { CountryParams } from './models/countryParams';
import { CountryStatesParams } from './models/countryStatesParams';
import { LocalizationService } from './localization';

declare let window: any;

let pca: any;
let scriptjs = require('scriptjs');

@Component({
    selector: 'address-autocomplete',
    providers: [
        Configuration,
        CountryHttpService,
        HttpConfiguration,
        LocalizationService
    ],
    template: require('./address-autocomplete.html')
})

export class AddressAutocompleteComponent {
    private control: any;
    private states: any = [];
    private countries: any = [];

    private restrictCountries =
    ['RU', 'AM', 'AZ', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'TM', 'UA', 'GE'];

    public message: any = [];
    public addressIsWrong = '#ccc';

    private countryRegionUseModelValue = true;
    private disableProvinceEdit = true;

    @Input() public locale_countryMark = false;
    @Input() public isLegacy = false;
    @Input() public useDevExpressValidation = false; //send True if you want to use devexpress validation style
    @Input() public name: any; //send a name if you want to make 2 or more components on page
    @Input() public controlWidthCss = 'col-md-9'; // control width
    @Input() public id: string;
    @Input() public validate = true; //send a validate value if you dont want validate form or if you want to hide it sometimes
    @Input() public model: AddressAutocompleteModel;
    @Input() public options: CandapostAutocompleteOptions; // = new CandapostAutocompleteOptions("ZN91-BE96-BP72-AB82");
    @Input() public addressType: Number;
    @Input() public locale = 'ru';
    @Input() public disabled = false;

    @Output() onFieldChangeEmit = new EventEmitter<any>();

    // countryStatesParams: CountryStatesParams;
    @HostBinding('class.address-autocomplete') hostCss = true;

    @ViewChild('fullAddress', { static: false }) private fullAddress: any;

    textboxPattern: any = '^(?!.*[\u0430-\u044F\u0410-\u042F\u0451\u0401]).*$';
    //messageEncoding: 'Нельзя вводить кириллические символы';

    constructor(
        private cfg: Configuration,
        private countryService: CountryHttpService,
        private vc: ViewContainerRef,
        private cdr: ChangeDetectorRef,
        public localizationService: LocalizationService) {
        this.options = new CandapostAutocompleteOptions(cfg.appSettings.canadaPost.key);
        this.localizationService = new LocalizationService();
    }

    getLocalized(text: string, locale: string): string {
        return this.localizationService.getLocalized(text, this.locale);
    }

    getObjectName(): string {
        return `autocomplete_${this.name}`;
    }

    ngAfterContentInit() {
        scriptjs('https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.js', this.onAddressInitialized.bind(this));
    }

    private onPopulate(address: ICanadapostAddress) {
        this.onAddressSelected(address);
    }

    private onError(error: any) {
        console.log(error);
    }

    private async onAddressSelected(address: ICanadapostAddress) {
        if (this.restrictCountries.indexOf(address.CountryIso2) > -1) {
            this.cleanForm();
            this.message = [this.getLocalized('serviceRestrictions', this.locale)];
        } else {
            this.message = [];
            this.model.city = address.City;
            this.model.countryRegion.country.iso2 = address.CountryIso2;
            this.model.address = address.Line1;
            this.model.address2 = address.Line2;
            this.model.province = address.ProvinceCode;
            this.model.postalCode = address.PostalCode;
            this.model.countryRegion.code = address.ProvinceCode;

            this.model.countryName = address.CountryName;
            this.model.provinceName = address.ProvinceName;

            await this.getStates(address.CountryIso2);

            if (this.checkStateIsWrong()) {
                //set null = save select box validation for province
                this.model.countryRegion.code = null;
                this.tryToFixProvince(address);
            }
        }

        this.checkAddressIsWrong();

        const event = {
            'event': 'checkout_interaction',
            'eventCategory': 'step_payment',
            'eventAction': 'payment_address',
            'eventLabel': 'address'
        };

        this.onFieldChangeEmit.emit(event);
    }

    cleanForm() {
        this.model.city = null;
        this.model.countryRegion.country.iso2 = null;
        this.model.address = null;
        this.model.address2 = null;
        this.states = [];
        this.model.province = null;
        this.model.postalCode = null;
        this.model.countryRegion.code = null;
    }

    isCanada(): boolean {
        return this.model.countryRegion.country.iso2 === 'CA';
    }

    isUsa(): boolean {
        return this.model.countryRegion.country.iso2 === 'US';
    }

    private onAddressInitialized() {
        this.countryRefresh();
        pca = window['pca'];
        if (!!pca) {
            if (!this.options) {
                throw new Error('"options" parameter must be set');
            }
            const controlSetup: any[] = [
                {
                    //element: this.fullAddress.nativeElement.id,
                    element: this.name,
                    field: 'Label',
                    mode: pca.fieldMode.DEFAULT
                }
            ];

            this.options.bar.showCountry = ((this.isLegacy) as any);
            this.options.bar.visible = ((this.isLegacy) as any);

            this.control = new pca.Address(controlSetup, this.options);
            this.control.listen('populate', this.onPopulate.bind(this));
            this.control.listen('error', this.onError.bind(this));
            this.buildInlineValue();
            this.model.enabled = true;
        } else {
            this.model.enabled = false;
        }
    }

    private countryRefresh(): void {
        const countryParams = new CountryParams();
        if (this.isLegacy != undefined) {
            countryParams.forLegacy = this.isLegacy;
        } else {
            countryParams.forLegacy = false;
        }
        if (this.addressType != undefined) {
            countryParams.addressType = this.addressType;
        } else {
            countryParams.addressType = 0;
        }

        this.countryService.getCountries(countryParams).subscribe((items: any) => {
            this.countries = items.filter((item: any) =>
                this.restrictCountries.indexOf(item.iso2) === -1);
        });
    }

    buildInlineValue(): void {
        this.model.addressInline =
            (this.model.address ? (this.model.address + ', ') : (''))
            +
            (this.model.city ? (this.model.city + ' ') : (''))
            +
            (this.model.province ? (this.model.province + ' ') : (''))
            +
            (this.model.postalCode ? (this.model.postalCode + ', ') : (''))
            +
            (this.model.countryRegion.country.iso2 ? (this.model.countryRegion.country.iso2) : (''));
    }

    autocompletekeyUp() {
        this.cleanForm();
        this.checkAddressIsWrong();
    }

    checkAddressIsWrong() {
        if (this.model.address == null ||
            this.model.city == null ||
            this.model.province == null ||
            this.model.postalCode == null ||
            this.model.countryRegion.country.iso2 == null ||
            this.checkStateIsWrong()
        ) {
            this.addressIsWrong = 'red';
        } else {
            this.addressIsWrong = '#ccc';
        }
    }

    private getCountryMark(): string {
        if (this.locale_countryMark) {
            return ' *';
        } else {
            return '';
        }
    }

    private checkStateIsWrong() {
        return this.states.filter((s: any) => s.code === this.model.countryRegion.code).length === 0;
    }

    private tryToFixProvince(address: ICanadapostAddress) {
        //if model.countryregion.code is number (for example always for GERMANY returns digital code) then we try to found province by name
        const states = this.states.filter((s: any) => s.name === address.ProvinceName);
        if (states.length > 0) {
            this.model.countryRegion.code = states[0].code;
        }

        if (this.states.length === 1) {
            this.model.countryRegion.code = this.states[0].code;
        }
    }

    private getCountryStatesParams(): CountryStatesParams {
        const countryStatesParams = new CountryStatesParams();
        if (this.isLegacy != undefined) {
            countryStatesParams.forLegacy = this.isLegacy;
        } else {
            countryStatesParams.forLegacy = false;
        }
        if (this.addressType != undefined) {
            countryStatesParams.addressType = this.addressType;
        } else {
            countryStatesParams.addressType = 0;
        }
        return countryStatesParams;
    }

    async getStates(value: any) {
        if (!value) {
            return;
        }

        const countryStatesParams = this.getCountryStatesParams();

        const myCountry = this.countries.filter((x: any) => x.iso2 === value);
        countryStatesParams.countryId = myCountry[0].id;

        this.states = await this.countryService.getStates(countryStatesParams).toPromise();
        const stateFilter = this.states.filter((item: any) => this.model.countryRegion.country.iso2 === item.code);
        if (stateFilter.length > 0) {
            this.model.countryRegion.id = stateFilter[0].id;
        }
    }

    provinceSelectionChanged(event: any) {
        if (event.selectedItem == null) {
            this.model.provinceName = null;
            return;
        }

        this.model.provinceName = event.selectedItem.name;
    }

    selectionChanged(event: any): void {
        const countryStatesParams = this.getCountryStatesParams();

        if (event.selectedItem == null) {
            this.model.countryName = null;
            console.log('No states provided for this country');
            return;
        }

        this.model.countryName = event.selectedItem.name;

        countryStatesParams.countryId = event.selectedItem.id;

        this.countryService.getStates(countryStatesParams).subscribe((items: any) => {
            this.states = items;

            if (items.length === 1 && items[0].code === '--') {
                this.disableProvinceEdit = true;
                this.model.countryRegion.code = items[0].code;
            } else {
                this.disableProvinceEdit = false;
            }
        });

        if (!this.countryRegionUseModelValue) {
            this.model.countryRegion.code = null;
        }
        this.countryRegionUseModelValue = false;

        const inputEvent = {
            'event': 'checkout_interaction',
            'eventCategory': 'step_payment',
            'eventAction': 'payment_address',
            'eventLabel': 'country'
        };

        this.onFieldChangeEmit.emit(inputEvent);
    }

    onInput(e: any) {
        const event = {
            'event': 'checkout_interaction',
            'eventCategory': 'step_payment',
            'eventAction': 'payment_address',
            'eventLabel': e.element.dataset.eventLabel
        };

        this.onFieldChangeEmit.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/address-autocomplete.component.ts